import { a as __assign } from '../../tslib.es6-2259bcab.js';
import * as React from 'react';

var styles = {"spinner":"Spinner_spinner_3090c5c7","spin":"Spinner_spin_3090c5c7","circle":"Spinner_circle_3090c5c7","dashOffset":"Spinner_dashOffset_3090c5c7"};

var Spinner = function (props) { return (React.createElement("svg", __assign({ className: styles.spinner, viewBox: "0 0 50 50" }, props),
    React.createElement("circle", { className: styles.circle, cx: "25", cy: "25", r: "20", fill: "none", stroke: "currentColor", strokeWidth: "5", strokeLinecap: "round" }))); };

export { Spinner };
